import { useSelector } from 'react-redux';

export const useThemeColors = (manualDarkMode = null) => {
    const reduxDark = useSelector((state) => state.pos?.darkMode);
    const isDark = manualDarkMode !== null ? manualDarkMode : reduxDark;

    return {
        themeBg: isDark ? '#121212' : '#ffffff',
        contentBg: isDark ? '#1a1a1a' : '#ffffff',
        cardBg: isDark ? '#242424' : '#f8f9fa',
        textColor: isDark ? '#ffffff' : '#212529',
        subTextColor: isDark ? '#a0a0a0' : '#6c757d',
        borderColor: isDark ? '#333333' : '#dee2e6',
        headerBg: isDark ? '#2a2a2a' : '#f1f1f1',
        isDark
    };
};